import { render, staticRenderFns } from "./EnvioInventarioView.vue?vue&type=template&id=f6283d84&"
import script from "./EnvioInventarioView.vue?vue&type=script&lang=js&"
export * from "./EnvioInventarioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports